/** F606 Products (Store) page — bridge-backed. */
import { Package } from 'lucide-react';
import F606DataPage from './F606DataPage';

export default function F606ProductsPage() {
  return (
    <F606DataPage
      entity="products"
      titleAr="المتجر"
      titleEn="Store products"
      icon={Package}
      emptyIcon={Package}
      columns={[
        {
          key: 'id',
          ar: '#', en: '#',
          render: (r) => <span className="font-mono text-white/40 text-[10px]" dir="ltr">{String(r.id || '').slice(0, 8)}</span>,
          className: 'w-20',
        },
        {
          key: 'name',
          ar: 'المنتج', en: 'Product',
          render: (r) => (
            <div>
              <div className="font-bold text-white">{r.name || r.title || '—'}</div>
              {r.category && <div className="text-[10px] text-white/40">{r.category}</div>}
            </div>
          ),
        },
        {
          key: 'price',
          ar: 'السعر', en: 'Price',
          render: (r) => r.price != null ? <span className="font-mono font-bold text-emerald-300" dir="ltr">{Number(r.price).toFixed(2)} {r.currency || 'AED'}</span> : '—',
          className: 'w-32',
        },
        { key: 'stock', ar: 'المخزون', en: 'Stock', render: (r) => r.stock ?? r.quantity ?? '—', className: 'w-20 text-center' },
        {
          key: 'is_active',
          ar: 'الحالة', en: 'Status',
          render: (r) => (
            <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold border ${
              r.is_active ?? true
                ? 'bg-emerald-500/15 border-emerald-500/40 text-emerald-300'
                : 'bg-white/5 border-white/10 text-white/50'
            }`}>
              {(r.is_active ?? true) ? 'active' : 'inactive'}
            </span>
          ),
          className: 'w-24',
        },
      ]}
    />
  );
}
